<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column pr-0">
        <div class="card flex-1-auto h-100 overflow-auto">
          <div class="card-header card-header-with-button">
              <h5>{{$t('ANSWERS')}}</h5>
              <button type="button" class="btn-bis btn-primary" @click="printToPdf()">{{$t('PDF')}}</button>
          </div>
            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                    <th>{{$t('EXPANDSTEP')}}</th>
                    <th>{{$t('NAME')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in data.root">
                    <tr :key="item.stepId" aria-rowindex="1" class="table-ellipsis">
                      <td>
                        <icon v-if="item.isExpanded === false" @click="item.isExpanded = true" icon="arrow-down" class="hover-mouse"></icon>
                        <icon v-if="item.isExpanded === true" @click="item.isExpanded = false" icon="arrow-up" class="hover-mouse"></icon>
                      </td>
                      <td>
                        <span v-if="stepContainsFix(item) && !item.defectForm" style="display: inline-block; width: 10px; height: 10px; background-color: orange; border-radius: 50%; margin-right: 5px; vertical-align: middle;"></span>
                        <span v-if="stepContainsDefect(item) && !item.defectForm" style="display: inline-block; width: 10px; height: 10px; background-color: red; border-radius: 50%; margin-right: 5px; vertical-align: middle;"></span>
                        <span v-if="item.defectForm" style="display: inline-block; background-color: orange; color: white; font-weight: bold; padding: 2px 6px; border-radius: 3px; font-size: 0.7em; margin-right: 5px; vertical-align: middle;">{{ $t('ANSWER_FIX_TAG') }}</span>
                        {{item.name}}
                      </td>
                    </tr>
                    <tr v-if="item.isExpanded === true" :key="`${item.stepId}_sec`" class="table-inside-table">
                          <td colspan="2" class="p-0">
                              <table class="table table-bis table-inside-table">
                                <thead>
                                  <tr>
                                    <th>{{$t('QUESTION')}}</th>
                                    <th>{{$t('ANSWER')}}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="(val, key) in item.answer">
                                    <tr :key="key" aria-rowindex="1" class="table-ellipsis">
                                      <td>
                                        <span v-if="val.defectLevel === 'fixed' && !item.defectForm" style="display: inline-block; width: 10px; height: 10px; background-color: orange; border-radius: 50%; margin-right: 5px; vertical-align: middle;"></span>
                                        <span v-if="val.defectLevel === 'defect' && !item.defectForm" style="display: inline-block; width: 10px; height: 10px; background-color: red; border-radius: 50%; margin-right: 5px; vertical-align: middle;"></span>
                                        {{val.label}}
                                      </td>
                                      <td v-if="val.questionType !== 'camera' && val.questionType !== 'signature'">{{getAnswer(val)}}</td>
                                      <td v-else>
                                        <img :src="val.answer">
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                          </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import Api from '@/api/job/JobAnswer.js';

export default {
    name: 'AnsersWin',
    data()
    {
        const me = this;

        return {
            loading: true,
            data: {},
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            searchTimeout: false,
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      getAnswer(val)
      {
        if (val.questionType === 'checkbox')
        {
          return val.answer == 0 ? 'No' : 'Yes';
        }
        return val.answer;
      },
      async printToPdf()
      {
          const me = this;
          try
          {
              await Api.printToPdf({ jobId: me.$route.params.jobId });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      stepContainsDefect(item)
      {
        for (const answer of item.answer) {
          if (answer.defectLevel === 'defect') {
            return true;
          }
        }
        return false;
      },
      stepContainsFix(item)
      {
        for (const answer of item.answer) {
          if (answer.defectLevel === 'fixed') {
            return true;
          }
        }
        return false;
      },
  },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          data.jobId = me.$route.params.jobId;
          return data;
      },
  },
};
</script>
